import React from 'react';
import { ChevronLeft, ChevronRight, Play, Pause } from 'lucide-react';
interface CompactNavigationProps {
  onPrev: () => void;
  onNext: () => void;
  isPlaying: boolean;
  onTogglePlay: () => void;
  canGoPrev: boolean;
  canGoNext: boolean;
}
export function CompactNavigation({
  onPrev,
  onNext,
  isPlaying,
  onTogglePlay,
  canGoPrev,
  canGoNext
}: CompactNavigationProps) {
  return <div className="fixed bottom-8 left-8 z-50 flex items-center gap-2 bg-slate-900/80 backdrop-blur-sm border border-slate-700 rounded-full p-2 shadow-xl" data-id="element-1">
      <button onClick={onPrev} disabled={!canGoPrev} className="p-2 rounded-full hover:bg-slate-700 text-slate-300 disabled:opacity-30 disabled:hover:bg-transparent transition-colors" aria-label="Previous slide" data-id="element-2">
        <ChevronLeft className="w-5 h-5" data-id="element-3" />
      </button>

      <button onClick={onTogglePlay} className="p-2 rounded-full hover:bg-blue-600 bg-blue-500/20 text-blue-400 hover:text-white transition-colors" aria-label={isPlaying ? 'Pause' : 'Play'} data-id="element-4">
        {isPlaying ? <Pause className="w-5 h-5" fill="currentColor" data-id="element-5" /> : <Play className="w-5 h-5" fill="currentColor" data-id="element-6" />}
      </button>

      <button onClick={onNext} disabled={!canGoNext} className="p-2 rounded-full hover:bg-slate-700 text-slate-300 disabled:opacity-30 disabled:hover:bg-transparent transition-colors" aria-label="Next slide" data-id="element-7">
        <ChevronRight className="w-5 h-5" data-id="element-8" />
      </button>
    </div>;
}